import { TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { ShowMoreTreeItem } from '../components/ShowMoreTreeItem.js'
import { TreeItems } from '../types.js'

function loadMoreCollectionTreeIndex(id: TreeItemIndex) {
  return `load-more-${id}`
}

export function createLoadMoreTreeItem(
  { $t }: I18nShape,
  {
    id,
    onClick,
  }: {
    id: TreeItemIndex
    onClick: () => void
  },
): TreeItems {
  return {
    [loadMoreCollectionTreeIndex(id)]: {
      index: loadMoreCollectionTreeIndex(id),
      isFolder: false,
      data: {
        type: 'simple',
        title: $t({
          id: 'Generics.ShowMore',
          defaultMessage: 'Show more',
        }) as string,
        render: () => <ShowMoreTreeItem onClick={onClick} />,
      },
    },
  }
}
